import { useEffect } from "react";
import { useApi } from "./useApi";
import { QONTO_ENABLED } from "../utils/featureFlags";

/**
 * Hook : déclenche une sync silencieuse Qonto à l'ouverture d'une page critique.
 *
 * Comportement :
 *  - Appel POST /api/qonto/sync/silent à chaque mount du composant qui l'utilise
 *  - Le backend est throttlé (30 sec) → pas de spam même si l'utilisateur navigue beaucoup
 *  - Pas de feedback visuel (sync en background)
 *  - Si onSyncTriggered fourni, callback exécuté quand le backend confirme une sync
 *    (utile pour recharger les ventes/dépenses ~3 sec plus tard)
 */
export const useQontoSilentSync = (onSyncTriggered) => {
  const api = useApi();

  useEffect(() => {
    if (!QONTO_ENABLED) return; // Feature flag : pas de sync Qonto en prod tant que le partenariat n'est pas signé
    let cancelled = false;
    (async () => {
      try {
        const res = await api.post("/qonto/sync/silent", {});
        if (cancelled) return;
        const status = res?.data?.status;
        if (status === "triggered" && typeof onSyncTriggered === "function") {
          // Donne 3 sec au backend pour finir l'upsert, puis recharge les données
          setTimeout(() => {
            if (!cancelled) onSyncTriggered();
          }, 3000);
        }
      } catch {
        // Silencieux : pas de feedback si Qonto pas connecté ou erreur réseau
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
